<div class="wrapper">

    <kendo-upload saveUrl="/api/core/files"
                  [multiple]="false"
                  (upload)="uploadEventHandler($event)"
                  [restrictions]="fileRestrictions"
                  (success)="successEventHandler($event)"
    >
        <ng-template kendoUploadFileTemplate let-files let-state="state">
            {{showErros(files)}}
            <p class="name" *ngIf="fileId && originalName">
                {{originalName}}<i class="bx bx-x" (click)="removeAfterUpload()"></i>
            </p>
        </ng-template>
    </kendo-upload>

    <ns-plus-button></ns-plus-button>

    <div *ngIf="showExtensionError" class="error">
        {{extensionError}}
    </div>
</div>
